import React, { FC, useEffect, useState } from 'react';

import { Box, Text } from '@rbilabs/universal-components';

import ActionButton from 'components/action-button';
import Dialog from 'components/dialog';
import { FavoriteInput } from 'components/favorite-input';
import { useKeyboardState } from 'hooks/use-keyboard-state';
import { t } from 'state/intl/translations';
import { isIOS, isWeb } from 'utils/environment';

import { ISaveFavoriteOrderProps } from './types';
/**
 *
 * Save Favorite Order
 *
 *
 */
export const SaveFavoriteOrder: FC<React.PropsWithChildren<ISaveFavoriteOrderProps>> = ({
  showDialog,
  onSave,
  onDismiss,
}) => {
  const [favoriteName, setFavoriteName] = useState<string>('');
  const [errorMessage, setErrorMessage] = useState<string>('');
  const { keyboardHeight, isKeyboardOpen } = useKeyboardState();

  const handleSave = () => {
    if (!favoriteName || favoriteName.trim() === '') {
      return setErrorMessage(t('saveFavoriteOrderNameError'));
    }
    onSave(favoriteName);
  };
  useEffect(() => {
    // this is a hack for IOS WEB bc the listener for the keyboard not always are called
    if (showDialog && isWeb && isIOS()) {
      window.scrollTo({
        top: 100,
        behavior: 'smooth',
      });
    }
  }, [showDialog]);

  return (
    <Dialog
      showDialog={showDialog}
      testID="save-favorite-order"
      showCloseButton
      onDismiss={onDismiss}
      modalAppearanceEventMessage="Save Favorite Order"
      heading={t('nameYourFavorite')}
      actions={
        <ActionButton fullWidth onPress={handleSave} testID="save-favorite-order-button">
          {t('saveFavoriteOrderButton')}
        </ActionButton>
      }
      maxHeight="full"
      marginBottom={isKeyboardOpen ? keyboardHeight : undefined}
    >
      <Text>{t('saveFavoriteOrderText')}</Text>
      <Box marginBottom={{ base: '$1.5', md: '$2' }}>
        <FavoriteInput
          errorMessage={errorMessage}
          onChange={setFavoriteName}
          testID="save-favorite-order-name"
          favoriteName={favoriteName}
          setErrorMessage={setErrorMessage}
        />
      </Box>
    </Dialog>
  );
};
